import React from 'react'

export default function IconFiveCol({ colour = 'currentColor', ...rest }) {
    return (
        <svg
            preserveAspectRatio='none'
            width='264'
            height='24'
            viewBox='0 0 264 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
        >
            <path
                d='M12 0.5H47.2002C49.1331 0.500107 50.7002 2.06707 50.7002 4V20C50.7002 21.9329 49.1331 23.4999 47.2002 23.5H12C10.067 23.5 8.5 21.933 8.5 20V4C8.5 2.067 10.067 0.5 12 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M12 0.5H47.2002C49.1331 0.500107 50.7002 2.06707 50.7002 4V20C50.7002 21.9329 49.1331 23.4999 47.2002 23.5H12C10.067 23.5 8.5 21.933 8.5 20V4C8.5 2.067 10.067 0.5 12 0.5Z'
                stroke='#E1E1E0'
            />
            <path
                d='M63.2002 0.5H98.4004C100.333 0.500107 101.9 2.06707 101.9 4V20C101.9 21.9329 100.333 23.4999 98.4004 23.5H63.2002C61.2672 23.5 59.7002 21.933 59.7002 20V4C59.7002 2.067 61.2672 0.5 63.2002 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M63.2002 0.5H98.4004C100.333 0.500107 101.9 2.06707 101.9 4V20C101.9 21.9329 100.333 23.4999 98.4004 23.5H63.2002C61.2672 23.5 59.7002 21.933 59.7002 20V4C59.7002 2.067 61.2672 0.5 63.2002 0.5Z'
                stroke='#E1E1E0'
            />
            <path
                d='M114.4 0.5H149.601C151.533 0.500107 153.101 2.06707 153.101 4V20C153.101 21.9329 151.533 23.4999 149.601 23.5H114.4C112.467 23.5 110.9 21.933 110.9 20V4C110.9 2.067 112.467 0.5 114.4 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M114.4 0.5H149.601C151.533 0.500107 153.101 2.06707 153.101 4V20C153.101 21.9329 151.533 23.4999 149.601 23.5H114.4C112.467 23.5 110.9 21.933 110.9 20V4C110.9 2.067 112.467 0.5 114.4 0.5Z'
                stroke='#E1E1E0'
            />
            <path
                d='M165.6 0.5H200.8C202.733 0.500107 204.3 2.06707 204.3 4V20C204.3 21.9329 202.733 23.4999 200.8 23.5H165.6C163.667 23.5 162.1 21.933 162.1 20V4C162.1 2.12727 163.57 0.598422 165.42 0.504883L165.6 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M165.6 0.5H200.8C202.733 0.500107 204.3 2.06707 204.3 4V20C204.3 21.9329 202.733 23.4999 200.8 23.5H165.6C163.667 23.5 162.1 21.933 162.1 20V4C162.1 2.12727 163.57 0.598422 165.42 0.504883L165.6 0.5Z'
                stroke='#E1E1E0'
            />
            <path
                d='M216.8 0.5H252C253.933 0.500107 255.5 2.06707 255.5 4V20C255.5 21.9329 253.933 23.4999 252 23.5H216.8C214.867 23.5 213.3 21.933 213.3 20V4C213.3 2.12727 214.771 0.598422 216.62 0.504883L216.8 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M216.8 0.5H252C253.933 0.500107 255.5 2.06707 255.5 4V20C255.5 21.9329 253.933 23.4999 252 23.5H216.8C214.867 23.5 213.3 21.933 213.3 20V4C213.3 2.12727 214.771 0.598422 216.62 0.504883L216.8 0.5Z'
                stroke='#E1E1E0'
            />
        </svg>
    )
}
